import React, { useEffect, useRef } from 'react';
import MarkdownText from './MarkdownText';
import './RepeatPracticeCard.css';

export default function RepeatPracticeCard({
  question, answer, memo, backMemo, onRepeat, disabled = false, repeatCount = 0,
  targetRepeats = 8, repeatLabel, children,
}) {
  const cardRef = useRef(null);
  useEffect(() => {
    const card = cardRef.current;
    if (!card) return undefined;
    const fit = () => {
      card.querySelectorAll('.learning-repeat-text').forEach(text => {
        let size = 24;
        text.style.fontSize = `${size}px`;
        while (size > 12 && (text.scrollHeight > text.clientHeight || text.scrollWidth > text.clientWidth)) {
          size -= 1;
          text.style.fontSize = `${size}px`;
        }
      });
    };
    fit();
    const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(fit) : null;
    observer?.observe(card);
    window.addEventListener('resize', fit);
    return () => { observer?.disconnect(); window.removeEventListener('resize', fit); };
  }, [question, answer, memo, backMemo]);

  return <button ref={cardRef} type="button" className="learning-repeat-card" onClick={onRepeat}
    disabled={disabled || repeatCount >= targetRepeats} aria-label={repeatLabel}>
    <span className="learning-repeat-faces">
      {[{ label:'Q', text:question, memo, className:'is-question' }, { label:'A', text:answer, memo:backMemo, className:'is-answer' }].map(side =>
        <span key={side.label} className={`learning-repeat-face ${side.className}`}>
          <span className="learning-repeat-label" aria-hidden="true">{side.label}</span>
          <span className="learning-repeat-text"><MarkdownText text={side.text || ''} />{side.memo && <MarkdownText className="learning-repeat-memo" text={side.memo} />}</span>
        </span>)}
    </span>
    {children}
  </button>;
}
